import { useMemo } from 'react';

import {
  buildToolTimeline,
  extractRecorderResult,
  type RecorderResult,
  type ToolEvent,
} from '@/sections/asset/components/tabs/credentials/RecorderProgress/buildTimeline';
import { useRecorderMessages } from '@/sections/asset/components/tabs/credentials/RecorderProgress/useRecorderMessages';

export interface RecorderOutcome {
  events: ToolEvent[];
  finalize?: ToolEvent;
  result: RecorderResult | null;
}

// Polls a recorder conversation and derives its tool timeline + terminal
// finalize result. Used by RecorderProgress to render the live timeline modal.
export function useRecorderOutcome(conversationId: string): RecorderOutcome {
  const messages = useRecorderMessages(conversationId);
  const events = useMemo(() => buildToolTimeline(messages), [messages]);
  const finalize = events.find(
    e => e.name === 'finalize' && e.status !== 'running'
  );
  const result = finalize ? extractRecorderResult(finalize) : null;
  return { events, finalize, result };
}
